import React from "react";
import { useState,useEffect } from "react";
import { FaCheckCircle } from "react-icons/fa";


const AdminNeedApprovalTask =({listOfTask, needApprovalFunction})=>{


    useEffect(()=>{
        console.log("Data In Item: ",listOfTask)
    },[listOfTask])

    return (
        <main className="dashboard-main">
          <h2>Pending Tasks</h2>
    
          <ul className="task-list-auto-task">
            {listOfTask && listOfTask.length > 0 ? (
              listOfTask.map((task, index) => (
                <li
                  key={task.id || index}
                  className={`task-item-need-approval-task`}
                >
                 {<input onClick={() => needApprovalFunction(index)}className="task-check" type="checkbox"></input>}
                  <p>Task Name: {task.stock_symbol} - {task.financial_type}</p>
                  <p>Task Status: {task.isapproved?"Approved":"Need Approval"}</p>
                  <p>Task Type: {task.financial_file_type}</p>
                  <p>Date Of Data Pull: {task.date_completed}</p>
                  <p>Year Of Financial Data:{task.date_of_financial_data} </p>
                </li>
              ))
            ) : (
              <p>No tasks found.</p>
            )}
          </ul>
        </main>
      );
}

export default AdminNeedApprovalTask;